export function WeedParts() {
  return <span className="flex size-full ">Em breve...</span>
}
